interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
}

export function Checkbox({ checked = false, onChange, className = '' }: CheckboxProps) {
  return (
    <div
      className={`app-checkbox ${checked ? 'checked' : ''} ${className}`}
      onClick={() => onChange?.(!checked)}
    />
  );
}
